import { render, staticRenderFns } from "./Salespeople.vue?vue&type=template&id=e4d3fbf6&"
import script from "./Salespeople.vue?vue&type=script&lang=js&"
export * from "./Salespeople.vue?vue&type=script&lang=js&"
import style0 from "./Salespeople.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports